import Caisse from '../../components/caisse/Caisse';

export default function CaisseServeur() {
  return <Caisse role="serveur" />;
}
